'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

var _IMEAware = require('./IMEAware');

var _IMEAware2 = _interopRequireDefault(_IMEAware);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var IMESafeComponent = function (_React$Component) {
    _inherits(IMESafeComponent, _React$Component);

    function IMESafeComponent(props) {
      _classCallCheck(this, IMESafeComponent);

      var _this = _possibleConstructorReturn(this, (IMESafeComponent.__proto__ || Object.getPrototypeOf(IMESafeComponent)).call(this, props));

      _this.handleKeyUp = _this.handleKeyUp.bind(_this);
      _this.handleKeyDown = _this.handleKeyDown.bind(_this);
      return _this;
    }

    _createClass(IMESafeComponent, [{
      key: 'handleKeyUp',
      value: function handleKeyUp(evt) {
        var _props = this.props,
            _composing = _props._composing,
            onKeyUp = _props.onKeyUp;

        if (!_composing) (0, _Functions.callIfPossible)(onKeyUp, evt);
      }
    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(evt) {
        var _props2 = this.props,
            _composing = _props2._composing,
            onKeyDown = _props2.onKeyDown;

        if (!_composing) (0, _Functions.callIfPossible)(onKeyDown, evt);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(Component, _extends({}, this.props, {
          onKeyUp: this.handleKeyUp,
          onKeyDown: this.handleKeyDown,
          ref: function ref(wrappedInstance) {
            (0, _utils.copyMethods)(wrappedInstance, _this2);
          }
        }));
      }
    }]);

    return IMESafeComponent;
  }(_react2.default.Component);

  IMESafeComponent.displayName = 'IMESafe(' + Component.displayName + ')';
  IMESafeComponent.propTypes = Component.propTypes;
  IMESafeComponent.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(IMESafeComponent, Component);
  return (0, _IMEAware2.default)(IMESafeComponent);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/decorators/IMESafe.js
// module id = 312
// module chunks = 0